import { render, staticRenderFns } from "./tire-recommend.vue?vue&type=template&id=a509d8e8&scoped=true&"
import script from "./tire-recommend.vue?vue&type=script&lang=js&"
export * from "./tire-recommend.vue?vue&type=script&lang=js&"
import style0 from "./tire-recommend.vue?vue&type=style&index=0&id=a509d8e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a509d8e8",
  null
  
)

export default component.exports